import api from '@/services/api/api'

class CollectionsService {
  getAllForView () {
    return api.get('collection/view').then(result => {
      return result.data
    })
  }
}

export default new CollectionsService()



// WEBPACK FOOTER //
// ./src/services/collection/CollectionsService.js